import Box from "@mui/material/Box";
import ELEMENT_IDS from "consts/element-ids";
import React, { useState } from "react";
import LeftMenu from "./LeftMenu";
import styles from "./styles.module.scss";
import Header from "./Header";

type AdminLayoutProps = {
  children: React.ReactNode;
};
const leftMenuWith = "256px";
const marginTopSize = "64px";
const paddingTopSize = "16px";
const paddingLeftRightSize = "24px";
function AdminLayout(props: AdminLayoutProps) {
  const { children } = props;
  return (
    <div>
      <Header />
      <LeftMenu />
      <Box
        component="main"
        className={styles.main}
        id="mainAdmin"
        style={{
          width: `calc(100% - ${leftMenuWith})`,
          marginTop: marginTopSize,
          marginLeft: leftMenuWith,
          paddingTop: paddingTopSize,
          paddingLeft: paddingLeftRightSize,
          paddingRight: paddingLeftRightSize,
          overflowY: "auto",
          overflowX: "hidden"
        }}
      >
        <Box className={styles.paper}>{children}</Box>
      </Box>
    </div>
  );
}

export default AdminLayout;
